<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" 
            :pagination="false" :loading="tloading" rowKey="id" >
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detail_servicetype',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'edit_servicetype',query: {id: record.id,}}">编辑</router-link>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            
            <template slot="isscreenid" slot-scope="text">
                <span>{{text == '01' ? '是' : '否'}}</span>
            </template>
            <template slot="iconid" slot-scope="text">
                <a-icon :type="text" />
            </template>
            
        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};
// channelcode: "CHANNEL-001"
// channelname: "商家银响力(商家后台)"
// createtime: "2021-09-18 17:46:04.0"
// createuser: "王国银"
// icon: "systems"
// id: "33"
// isscreen: "01"
// messagestypecode: "MSGTYPECODE-023"
// messagestypename: "系统消息"
// ordernum: "1"
// updatetime: "2021-09-18 17:46:04.0"
// updatetuser: "王国银"
const columns = [
    // {
    //     title: "序号",
    //     width: 50,
    //     align: "center",
    //     customRender: (text, record, index) => {
    //         let { page, pageSize } = pagination;
    //         return (Number(page) - 1) * Number(pageSize) + index + 1;
    //     }
    // },
    {
        title: "业务分类编码",
        dataIndex: "messagestypecode",
        align: "center",
        width:150
    },
    {
        title: "业务分类名",
        dataIndex: "messagestypename",
        align: "center",
        width:120
    },
    
    {
        title: "渠道编码",
        dataIndex: "channelcode",
        align: "center",
        width:120
    },
    {
        title: "渠道名称",
        dataIndex: "channelname",
        align: "center",
        width:150
    },
  

    {
        title: "是否订阅",
        dataIndex: "isscreen",
        scopedSlots: { customRender: 'isscreenid'},
        align: "center",
        width:80
    },
    {
        title: "图标",
        dataIndex: "icon",
        align: "center",
        width:100
    },
    {
        title: "排序",
        dataIndex: "ordernum",
        align: "center",
        width:100
    },

    
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:200
    },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatetime",
    //     width:150
    // },
    // {
    //     title: "更新人",
    //     dataIndex: "updatetuser",
    //     width:150
    // },
    {
        title: "创建人",
        dataIndex: "createuser",
        width:100
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            searchP:{},
        };
    },
    methods: {

        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/mcmsmessagetypeDel",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "mcmsmanager/mcmsmessagetypeQuery",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },

    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

